export const CONTENT: { [key: string]: string }[] = [
  {
    title: 'Я не хочу, чтобы про моего клиента узнала налоговая, что делать?',
    text: 'По закону вы должны платить налог с дохода от аренды, но онлайн-договор на это не влияет. Мы просто предупреждаем, а подавать документы или нет, решать вам. Кстати, у самозанятых налог всего 4%.',
    borderType: 'right',
  },
  {
    title: 'Как расторгнуть онлайн-договор?',
    text: 'Онлайн-договор полностью равноценен бумажному, процесс расторжения точно такой же',
    borderType: 'left',
  },
  {
    title: 'А как же очная встреча с участниками сделки?',
    text: 'Встречу и подписание онлайн-договора можно совместить — так всё пройдёт под вашим контролем',
    borderType: 'right',
  },
  {
    title: 'Как получить мою комиссию при онлайн-договоре?',
    text: 'Так же, как и при обычном — и размер, и способ получения комиссии вы определяете сами',
    borderType: 'left',
  },
  {
    title: 'Онлайн-договор имеет такую же юридическую силу, как бумажный?',
    text: 'Да, договоры равноценно законны: онлайн-версию подготовили специалисты Госуслуг, в ней прописаны права и обязанности обеих сторон',
    borderType: 'left',
  },
  {
    title: 'Если на объявлении есть значок «Онлайн-договор» — значит, подписать бумажный договор нельзя?',
    text: 'Нет, вы всегда можете выбрать любой удобный тип договора — онлайн или бумажный',
    borderType: 'left',
  },
];
